import { useEffect } from "react";
import { useTrialStatus } from "../contexts/BalanceContext";
import { useNavigate } from "react-router-dom";

export const TrialBanner = () => {
  const { trailStatus, handleTrialStatus } = useTrialStatus();
  const navigate = useNavigate();
  useEffect(() => {
    handleTrialStatus();
  }, []);
    
  

  if (!trailStatus || trailStatus.has_subscription) {
    return null;
  }
  const isExpired = !trailStatus.has_subscription;
  const handleSubscribeClick = () => {
    navigate("/company/flowsetting", {
      state: { activeTab: "Subscription" },
    });
  };
  // const urgency = trailStatus.days_left <= 3 ? "urgent" : "normal";

  return (
    <div className="px-6 mt-4 max-w-7xl mx-auto flex items-center justify-between">
      <div
        className={`text-sm font-medium ${
          isExpired ? "text-red-500" : "text-green-500"
        }`}
      >
        {trailStatus?.message?.toUpperCase()}
      </div>

      <button
        onClick={handleSubscribeClick}
        className="px-3 py-1 text-sm bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
      >
        Subscribe
      </button>
    </div>

    // <div className="relative  text-white-700 py-2 overflow-hidden">
    //   {/* Scrolling Message */}
    //   <div className="whitespace-nowrap  text-sm font-medium">
    //     {trailStatus?.message ||
    //       "Your trial has ended. Please subscribe to continue using the service."}
    //   </div>

    /* Subscribe Button */
    /* <button
       onClick={handleSubscribeClick}
        className="absolute right-4 top-1/2 -translate-y-1/2 px-3 py-1 text-sm bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
      >
        Subscribe
      </button> */
    // </div>
    // <div
    //   className="gap-4"
    //   //   className={`w-full flex items-center justify-between px-4 py-2 rounded-md
    //   //   ${urgency ? "bg-red-100 text-red-700" : "bg-yellow-100 text-yellow-800"}`}
    // >
    //   <span className="text-sm font-medium">{trailStatus?.message}</span>

    //   <button className="px-3 py-1 text-sm bg-indigo-600 text-white rounded-md hover:bg-indigo-700 ">
    //     Subscribe
    //   </button>
    // </div>
  );
};
